import { ROUTES } from "../../common/constants";
import { clauseCheckDocStatus } from "../vscDashboard/constants";
import {
  BulkClauseTableData,
  BulkClauseTableEntity,
  BulkSummaryTableData,
  BulkSummaryTableEntity,
  ContractTableData,
  ContractTableEntity,
  DraftingTableData,
  DraftingTableEntity,
  RfxEvaluationTableData,
  RfxEvaluationTableEntity,
  UserManagementTable,
  GeneratedRfxTableEntity,
  GeneratedRfxTableData,
  WorkBenchTableEntity,
  WorkBenchTableData,
} from "./model";

export const TableTypes = {
  DRAFTING_DASHBOARD: "drafting_dashboard",
  REVIEW_PENDING_DASHBOARD: "review_pending_dashboard",
  REVIEW_PENDING: "review_pending",
  REVEIW_COMPLETED: "review_completed",
  BULK_CLAUSE_DASHBOARD: "bulk_clause_dashboard",
  BULK_CLAUSE: "bulk_clause",
  USER_MANAGEMENT: "user_managment",
  BULK_SUMMARY: "bulk_summary",
  RFX_EVALUATION_DASHBOARD: "rfx_evaluation_dashboard",
  RFX_GENERATOR_DASHBOARD: "rfx_generator_dashboard",
  workBenchDashboard : "work_bench_dashboard",
};

export const ReviewTypes = {
  PENDING_REVIEW: "Pending Review",
  COMPLETED_REVIEW: "Completed Review",
};

export const TableUrlMap = {
  [TableTypes.REVIEW_PENDING]: ReviewTypes.PENDING_REVIEW,
  [TableTypes.REVEIW_COMPLETED]: ReviewTypes.COMPLETED_REVIEW,
};

export const SORT = {
  ASC: "ASC",
  DESC: "DESC",
};

export const PaginationActions = {
  FIRST: "First",
  PREVIOUS: "Previous",
  NEXT: "Next",
  LAST: "Last",
};

export const TABLECELL = {
  TOOLTIP: "tooltip",
  BADGE: "badge",
  PILL: "pill",
  VENDORANDDOC: "vendorAndDocType",
  STRING: "string",
  USER_ROLES: "userRoles",
  USER_ACTIONS: "userActions",
  POWER_USER: "powerUser",
  CONTRACT_ID_TOOLTIP: "contractIdTooltip",
  USER_PROFILE: "userProfile",
  ELLIPSIS_TEXT: "ellipsisText",
  DATE: "date",
  DATEANDTIME: "dateAndTime",
  PILLBU : "pillBu",
  VIEW: "view", // Added for View column
};

export const hiddenOptionsForManageTable = ["Vendor", "Title", "Contract ID"];

export const tableConfiguration: any = {
  [TableTypes.RFX_EVALUATION_DASHBOARD]: {
    dataObject: RfxEvaluationTableData,
    dataEntity: RfxEvaluationTableEntity,
    withSorting: true,
    preventResetPath: ROUTES.clauseSummary,
    tableColumns: [
      {
        title: "Date",
        key: "dateAndTime",
        type: TABLECELL.DATEANDTIME,
        category: "date",
        withSorting: false,
      },

      {
        title: "Product Area",
        key: "productAreaName",
        type: TABLECELL.STRING,
        category: "Title",
        withSorting: false,
      },

      {
        title: "RFx Name",
        key: "rfxFileName",
        type: TABLECELL.STRING,
        category: "Contract ID",
        withSorting: false,
      },
      {
        title: "Number of Responses",
        key: "countOfRfxResponse",
        type: TABLECELL.TOOLTIP,
        category: "SLA Penalties/Earn Back",
        withSorting: false,
      },

      {
        title: "Top Agency",
        key: "topAgency",
        type: TABLECELL.STRING,
        category: "Volume Discounts",
        withSorting: false,
      },
    ],
    paginationType: "advance",
    polingInterval: 4000,
  },
  [TableTypes.workBenchDashboard]: {
    dataObject: WorkBenchTableData,
    dataEntity: WorkBenchTableEntity,
    withSorting: false,
    toBeRetrieved: 10,
    preventResetPath: ROUTES.manageContracts,
    tableColumns: [
      {
        title: "Request",
        key: "request",
        type: TABLECELL.STRING,
        withSorting: false,
      },
      {
        title: "Budget",
        key: "budget",
        type: TABLECELL.STRING,
        withSorting: false,
      },
      {
        title: "Contracting Officer",
        key: "categorymanager", 
        type: TABLECELL.STRING,
        withSorting: false,
      },
      {
        title: "Status",
        key: "status",
        type: TABLECELL.PILLBU,
        withSorting: false,
      },
      {
        title: "View",
        key: "view",
        type: TABLECELL.VIEW,
        withSorting: false,
      },
    ],
    paginationType: "default",
  },
  [TableTypes.DRAFTING_DASHBOARD]: {
    dataObject: DraftingTableData,
    dataEntity: DraftingTableEntity,
    withSorting: false,
    toBeRetrived: 10,
    preventResetPath: ROUTES.manageContracts,
    tableColumns: [
      {
        title: "Vendor",
        key: "vendorNameMetadata",
        type: TABLECELL.STRING,
        withSorting: false,
      },
      {
        title: "Contract Name",
        key: "contractFileName",
        type: TABLECELL.TOOLTIP,
        withSorting: false,
      },
      {
        title: "Intake Form",
        key: "termsheet",
        type: TABLECELL.STRING,
        withSorting: false,
      },
      {
        title: "Template",
        key: "templateType",
        type: TABLECELL.STRING,
        withSorting: false,
      },
    ],
    paginationType: "default",
  },
  [TableTypes.RFX_GENERATOR_DASHBOARD]: {
    dataObject: GeneratedRfxTableData,
    dataEntity: GeneratedRfxTableEntity,
    withSorting: false,
    toBeRetrieved: 10,
    preventResetPath: ROUTES.manageContracts,
    tableColumns: [
      {
        title: "Product Area",
        key: "productAreaMetadata",
        type: TABLECELL.STRING,
        withSorting: false,
      },
      {
        title: "RFx Name",
        key: "rfxFileName",
        type: TABLECELL.TOOLTIP,
        withSorting: false,
      },
      {
        title: "Intake Form",
        key: "intakeFormTemplateName",
        type: TABLECELL.STRING,
        withSorting: false,
      },
      {
        title: "Template",
        key: "rfxTemplateName",
        type: TABLECELL.STRING,
        withSorting: false,
      },
      {
        title: "Date",
        key: "dateAndTime",
        type: TABLECELL.DATEANDTIME,
        withSorting: false,
      },
    ],
    paginationType: "default",
  },
  [TableTypes.REVIEW_PENDING_DASHBOARD]: {
    dataObject: ContractTableData,
    dataEntity: ContractTableEntity,
    withSorting: false,
    toBeRetrived: 10,
    preventResetPath: ROUTES.manageContracts,
    tableColumns: [
      {
        title: "Vendor",
        key: "vendorName",
        type: TABLECELL.STRING,
        withSorting: false,
      },
      {
        title: "Contract Name",
        key: "file",
        type: TABLECELL.TOOLTIP,
        withSorting: false,
      },

      // {
      //   title: "Contract ID",
      //   key: "contractId",
      //   type: TABLECELL.CONTRACT_ID_TOOLTIP,
      //   withSorting: false,
      // },

      {
        title: "Contract Type",
        key: "contractType",
        type: TABLECELL.STRING,
        withSorting: false,
      },
      // {
      //   title: "Start Date",
      //   key: "startDate",
      //   type: TABLECELL.STRING,
      //   withSorting: false,
      // },
      // {
      //   title: "End Date",
      //   key: "endDate",
      //   type: TABLECELL.STRING,
      //   withSorting: false,
      // },
      {
        title: "MTC",
        key: "mtc",
        type: TABLECELL.STRING,
        withSorting: false,
      },
    ],
    paginationType: "default",
  },
  [TableTypes.REVIEW_PENDING]: {
    dataObject: ContractTableData,
    dataEntity: ContractTableEntity,
    withSorting: false,
    toBeRetrived: 10,
    preventResetPath: ROUTES.manageContracts,
    tableColumns: [
      {
        title: "Vendor",
        key: "vendorName",
        type: TABLECELL.STRING,
        withSorting: false,
      },
      {
        title: "Contract Name",
        key: "file",
        type: TABLECELL.TOOLTIP,
        withSorting: false,
      },

      {
        title: "Contract ID",
        key: "contractId",
        type: TABLECELL.CONTRACT_ID_TOOLTIP,
        withSorting: false,
      },

      {
        title: "Contract Type",
        key: "contractType",
        type: TABLECELL.STRING,
        withSorting: false,
      },
      {
        title: "Start Date",
        key: "startDate",
        type: TABLECELL.STRING,
        withSorting: false,
      },
      {
        title: "End Date",
        key: "endDate",
        type: TABLECELL.STRING,
        withSorting: false,
      },
      {
        title: "MTC",
        key: "mtc",
        type: TABLECELL.STRING,
        withSorting: false,
      },
    ],
    paginationType: "default",
  },
  [TableTypes.REVEIW_COMPLETED]: {
    dataObject: ContractTableData,
    dataEntity: ContractTableEntity,
    withSorting: false,
    toBeRetrived: 10,
    preventResetPath: ROUTES.manageContracts,
    tableColumns: [
      {
        title: "Vendor",
        key: "vendorName",
        type: TABLECELL.STRING,
        withSorting: false,
      },
      {
        title: "Contract Name",
        key: "file",
        type: TABLECELL.TOOLTIP,
        withSorting: false,
      },

      {
        title: "Contract ID",
        key: "contractId",
        type: TABLECELL.CONTRACT_ID_TOOLTIP,
        withSorting: false,
      },

      {
        title: "Contract Type",
        key: "contractType",
        type: TABLECELL.STRING,
        withSorting: false,
      },
      {
        title: "Start Date",
        key: "startDate",
        type: TABLECELL.STRING,
        withSorting: false,
      },
      {
        title: "End Date",
        key: "endDate",
        type: TABLECELL.STRING,
        withSorting: false,
      },
      {
        title: "MTC",
        key: "mtc",
        type: TABLECELL.STRING,
        withSorting: false,
      },
    ],
    paginationType: "default",
  },
  [TableTypes.BULK_CLAUSE_DASHBOARD]: {
    dataObject: BulkClauseTableData,
    dataEntity: BulkClauseTableEntity,
    withSorting: false,
    preventResetPath: ROUTES.bulkClauseCheck,
    tableColumns: [
      {
        title: "Vendor",
        key: "vendorWithType",
        type: TABLECELL.VENDORANDDOC,
        withSorting: false,
      },

      {
        title: "Contract Name",
        key: "title",
        type: TABLECELL.TOOLTIP,
        withSorting: false,
      },

      {
        title: "Contract ID",
        key: "contractId",
        type: TABLECELL.CONTRACT_ID_TOOLTIP,
        withSorting: false,
      },
      {
        title: "Start Date",
        key: "startDate",
        type: TABLECELL.STRING,
        withSorting: false,
      },
      {
        title: "End Date",
        key: "endDate",
        type: TABLECELL.STRING,
        withSorting: false,
      },
      {
        title: "MTC",
        key: "mtc",
        type: TABLECELL.STRING,
        withSorting: false,
      },

      {
        title: "Status",
        key: "status",
        type: TABLECELL.PILL,
        withSorting: false,
      },
    ],
    paginationType: "advance",
    polingInterval: 1500,
  },
  [TableTypes.BULK_CLAUSE]: {
    dataObject: BulkClauseTableData,
    dataEntity: BulkClauseTableEntity,
    withSorting: false,
    preventResetPath: ROUTES.bulkClauseCheck,
    tableColumns: [
      {
        title: "Vendor",
        key: "vendorWithType",
        type: TABLECELL.VENDORANDDOC,
        withSorting: false,
      },

      {
        title: "Title",
        key: "title",
        type: TABLECELL.TOOLTIP,
        withSorting: false,
      },

      {
        title: "Contract ID",
        key: "contractId",
        type: TABLECELL.CONTRACT_ID_TOOLTIP,
        withSorting: false,
      },
      {
        title: "Start Date",
        key: "startDate",
        type: TABLECELL.STRING,
        withSorting: false,
      },
      {
        title: "End Date",
        key: "endDate",
        type: TABLECELL.STRING,
        withSorting: false,
      },
      {
        title: "MTC",
        key: "mtc",
        type: TABLECELL.STRING,
        withSorting: false,
      },

      {
        title: "Status",
        key: "status",
        type: TABLECELL.PILL,
        withSorting: false,
      },
    ],
    paginationType: "advance",
    polingInterval: 1500,
  },
  [TableTypes.BULK_SUMMARY]: {
    dataObject: BulkSummaryTableData,
    dataEntity: BulkSummaryTableEntity,
    withSorting: true,
    preventResetPath: ROUTES.clauseSummary,
    tableColumns: [
      {
        title: "Vendor",
        key: "vendorWithType",
        type: TABLECELL.VENDORANDDOC,
        category: "Vendor",
        withSorting: false,
      },

      {
        title: "Title",
        key: "title",
        type: TABLECELL.TOOLTIP,
        category: "Title",
        withSorting: false,
      },

      {
        title: "Contract ID",
        key: "contractId",
        type: TABLECELL.CONTRACT_ID_TOOLTIP,
        category: "Contract ID",
        withSorting: false,
      },
      {
        title: "SLA Penalties/Earn Backs",
        key: "earnBack",
        type: TABLECELL.BADGE,
        category: "SLA Penalties/Earn Back",
        withSorting: true,
      },

      {
        title: "Volume Discounts",
        key: "volumeDiscount",
        type: TABLECELL.BADGE,
        category: "Volume Discounts",
        withSorting: true,
      },

      {
        title: "Investments",
        key: "investments",
        type: TABLECELL.BADGE,
        category: "Non-EPP Investments",
        withSorting: true,
      },
      {
        title: "Productivity Improvements",
        key: "prodImprove",
        type: TABLECELL.BADGE,
        category: "Productivity Improvements",
        withSorting: true,
      },
      {
        title: "Buffer/Bench Recommendations",
        key: "benchRecommendation",
        type: TABLECELL.BADGE,
        category: "Committed Buffer/Bench Pool",
        withSorting: true,
      },
      {
        title: "Overtime / On-Call & Hourly Bill Rates",
        key: "overtime",
        type: TABLECELL.BADGE,
        category: "Overtime/On-call & Holiday Bill Rates",
        withSorting: true,
      },
    ],
    paginationType: "advance",
    polingInterval: 4000,
  },
  [TableTypes.USER_MANAGEMENT]: {
    dataObject: UserManagementTable,
    paginationType: "advance",
    preventResetPath: ROUTES.adminDashboard,
    tableColumns: [
      {
        title: "Name",
        key: "profileDetails",
        type: TABLECELL.USER_PROFILE,
        withSorting: false,
      },
      {
        title: "Email ID",
        key: "email",
        type: TABLECELL.STRING,
        withSorting: false,
      },
      {
        title: "Role",
        key: "roles",
        type: TABLECELL.USER_ROLES,
        withSorting: false,
      },
      // {
      //   title: "Power User",
      //   key: "powerUser",
      //   type: TABLECELL.POWER_USER,
      //   withSorting: false,
      // },
      {
        title: "\u00A0",
        key: "actions",
        type: TABLECELL.USER_ACTIONS,
        withSorting: false,
      },
    ],
  },
};

export const reviewPendingApiProp = {
  doc_status: TableTypes.REVIEW_PENDING,
};
export const reviewCompletedApiProps = {
  doc_status: "review_completed",
};

export const downloadStatusesforLatestUpload = [
  clauseCheckDocStatus.CLAUSE_CHECK_READY,
];

export const downloadStatuses = [
  clauseCheckDocStatus.CLAUSE_CHECK_READY,
  clauseCheckDocStatus.CLAUSE_CHECK_COMPLETED,
];

export const clauseSummaryApiProps = {
  clause_status: [
    clauseCheckDocStatus.CLAUSE_CHECK_READY,
    clauseCheckDocStatus.CLAUSE_CHECK_COMPLETED,
  ],
};
export const clauseSummaryApiPropsForLatestUpload = {
  clause_status: [clauseCheckDocStatus.CLAUSE_CHECK_READY],
};
